export default "/_next/static/images/img2-0b7b11df63ecad2c3e126236b9b446d3.png";